module.exports = __webpack_public_path__ + "static/media/turtle.a356ec22.svg";